import React, {useContext, useEffect, useState} from 'react';

import {useTranslation} from "react-i18next";
import {Link} from 'react-router-dom';
import axios from "axios";
import {baseURL} from "../services/api";
import OrgContext from "../organisation/OrgContext";

const ModelEmail = () => {
    const {organisation, changeOrg} = useContext(OrgContext);
    const [invoiceNotification, setInvoiceNotification] = useState([]);
    const [devisNotification, setDevisNotification] = useState([]);
    const [factureAvoirNotification, setFactureAvoirNotification] = useState([]);
    const [factureImpayeNotification, setFactureImpayeNotification] = useState([]);
    const [bnLivraisonNotification, setBnLivraisonNotification] = useState([]);

    useEffect(() => {
        getAllModeles('notification de facture');
        getAllModeles('Notification du devis');
        getAllModeles('Notification d\'une facture d\'avoir');
        getAllModeles('Lettre de relance en cas d\'impayé');
        getAllModeles('Notification du bon de livraison');

        console.log(organisation.id)
    }, []);
    const getAllModeles = async (type) => {
        await axios
            .get(baseURL + `/modele/${type}/${organisation.id}`)
            .then((response) => {
                if(type === 'notification de facture')
                    setInvoiceNotification(response.data.data);
                if(type === 'Notification du devis')
                    setDevisNotification(response.data.data);
                if(type === "Notification d'une facture d'avoir")
                    setFactureAvoirNotification(response.data.data);
                if(type === "Lettre de relance en cas d'impayé")
                    setFactureImpayeNotification(response.data.data);
                if(type === "Notification du bon de livraison")
                    setBnLivraisonNotification(response.data.data);

            })
            .catch((error) => console.log("error while retrieving data : " + error))
    }
    return (
        <>
            <div className="main-container container-fluid">
                <div className="page-header">
                    <h1 className="page-title">Modele des e-emails</h1>
                </div>
                <div className="row">
                    <div className="accordion" id="accordionExample">
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingFour">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseFive" aria-expanded="false"
                                        aria-controls="collapseFive">
                                    Notification de facture
                                </button>
                            </h2>
                            <div id="collapseFive" className="accordion-collapse collapse"
                                 aria-labelledby="headingFour" data-bs-parent="#accordionExample">
                                <div className="card-body">

                                    {
                                        invoiceNotification.map((invoiceNotification) => {
                                            return (
                                                <div className="example" style={{marginBottom: '20px'}}>
                                                    <div className="media media-lg mt-0">
                                                        <div className="media-body mt-0">
                                                            <h4 className="mt-0 mb-4">
                                                                <Link to={`/modele/${invoiceNotification.id}`}>
                                                                    {invoiceNotification.name}
                                                                </Link>
                                                            </h4>
                                                            <div dangerouslySetInnerHTML={{ __html: invoiceNotification.content }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }

                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headerNotificationDevis">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#collapseHeaderNotificationDevis" aria-expanded="false"
                                        aria-controls="collapseHeaderNotificationDevis">
                                    Notification du devis
                                </button>
                            </h2>
                            <div id="collapseHeaderNotificationDevis" className="accordion-collapse collapse"
                                 aria-labelledby="headerNotificationDevis" data-bs-parent="#accordionExample">
                                <div className="card-body">

                                    {
                                        devisNotification.map((devisNotification) => {
                                            return (
                                                <div className="example" style={{marginBottom: '20px'}}>
                                                    <div className="media media-lg mt-0">
                                                        <div className="media-body mt-0">
                                                            <h4 className="mt-0 mb-4">
                                                                <Link to={`/modele/${devisNotification.id}`}>
                                                                    {devisNotification.name}
                                                                </Link>
                                                            </h4>
                                                            <div dangerouslySetInnerHTML={{ __html: devisNotification.content }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }

                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headerNotificationFactureAvoir">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#coolapseHeaderNotificationFactureAvoir" aria-expanded="false"
                                        aria-controls="coolapseHeaderNotificationFactureAvoir">
                                    Notification d'une facture d'avoir
                                </button>
                            </h2>
                            <div id="coolapseHeaderNotificationFactureAvoir" className="accordion-collapse collapse"
                                 aria-labelledby="headerNotificationFactureAvoir" data-bs-parent="#accordionExamplee">
                                <div className="card-body">

                                    {
                                        factureAvoirNotification.map((fa) => {
                                            return (
                                                <div className="example" style={{marginBottom: '20px'}}>
                                                    <div className="media media-lg mt-0">
                                                        <div className="media-body mt-0">
                                                            <h4 className="mt-0 mb-4">
                                                                <Link to={`/modele/${fa.id}`}>
                                                                    {fa.name}
                                                                </Link>
                                                            </h4>
                                                            <div dangerouslySetInnerHTML={{ __html: fa.content }} />
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }

                                </div>
                            </div>
                        </div>

                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headerNotificationFactureImpaye">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#coolapseHeaderNotificationFactureImpaye" aria-expanded="false"
                                        aria-controls="coolapseHeaderNotificationFactureImpaye">
                                    Lettre de relance en cas d'impayé
                                </button>
                            </h2>
                            <div id="coolapseHeaderNotificationFactureImpaye" className="accordion-collapse collapse"
                                 aria-labelledby="headerNotificationFactureImpaye" data-bs-parent="#accordionExamplee">
                                <div className="card-body">

                                    {
                                        factureImpayeNotification.map((fa) => {
                                            return (
                                                <div className="example" style={{marginBottom: '20px'}}>
                                                    <div className="media media-lg mt-0">
                                                        <div className="media-body mt-0">
                                                            <h4 className="mt-0 mb-4">
                                                                <Link to={`/modele/${fa.id}`}>
                                                                    {fa.name}
                                                                </Link>
                                                            </h4>
                                                            <div dangerouslySetInnerHTML={{__html: fa.content}}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }

                                </div>
                            </div>
                        </div>

                        {/* <div className="accordion-item">
                            <h2 className="accordion-header" id="headerNotificationBnLivraison">
                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                        data-bs-target="#coolapseHeaderNotificationBnLivraison" aria-expanded="false"
                                        aria-controls="coolapseHeaderNotificationBnLivraison">
                                    Notification du bon de livraison
                                </button>
                            </h2>
                            <div id="coolapseHeaderNotificationBnLivraison" className="accordion-collapse collapse"
                                 aria-labelledby="headerNotificationBnLivraison" data-bs-parent="#accordionExamplee">
                                <div className="card-body">

                                    {
                                        bnLivraisonNotification.map((fa) => {
                                            return (
                                                <div className="example" style={{marginBottom: '20px'}}>
                                                    <div className="media media-lg mt-0">
                                                        <div className="media-body mt-0">
                                                            <h4 className="mt-0 mb-4">
                                                                <Link to={`/modele/${fa.id}`}>
                                                                    {fa.name}
                                                                </Link>
                                                            </h4>
                                                            <div dangerouslySetInnerHTML={{__html: fa.content}}/>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })
                                    }

                                </div>
                            </div>
                        </div> */}

                    </div>
                </div>
            </div>
        </>
    );
}

export default ModelEmail;